import { User } from '../../../firebase/firestore/documents/user';
import { useQuerySnapshot } from '../../../firebase/firestore/hooks';
import { Collections } from '../../../firebase/firestore/collections';
import { Query } from '../../../firebase/firestore/query/query';
import { useStoreState } from '../../../models/hooks';

export enum TeamMemberStateEnum {
  LOADING,
  READY,
}

export type TeamMembersState = {
  state: TeamMemberStateEnum;
  teamMembers: User[];
};

const useTeamMembers = (): TeamMembersState => {
  const { user } = useStoreState((state) => state.app);

  const teamMembers: User[] | undefined = useQuerySnapshot<User>(Collections.USERS, [
    Query.field<User>('account').equals(user?.account),
  ]);

  if (!teamMembers || !user) {
    return { state: TeamMemberStateEnum.LOADING, teamMembers: [] };
  }

  const filteredTeamMembers = teamMembers.filter(
    (member: User) => !member.ghost && !member.anonymousUser && member.firstName !== 'anonymous',
  );

  return {
    state: TeamMemberStateEnum.READY,
    teamMembers: filteredTeamMembers,
  };
};

export default useTeamMembers;
